const lang = {
    locale: '',
    languages: {}
};

const languageModule = {
        namespaced: true,
        state: {
            language: lang,
            locales: [],
            testingLanguage: '',
        },
        mutations: {
            SET_LANGUAGE: (state, language) => {
                state.language = language;
            },
            SET_LOCALES: (state, locales) => {
                state.locales = locales;
            },
            SET_TESTING_LANGUAGE: (state, language) => {
                state.testingLanguage = language;
            }
        },
        getters: {
            getLanguage: state => state.language,
            getTranslations: state => state.language.languages,
            getCurrentLocale: state => state.language.locale,
            getLocales: state => state.locales,
            getTestingLanguage: state => state.testingLanguage,
        },
        actions: {
            setLanguage: ({commit}, value) => {
                commit('SET_LANGUAGE', value);
            },
            setLocales: ({commit}, value) => {
                commit('SET_LOCALES', value);
            },
            setTestingLanguage: ({commit}, value) => {
                commit('SET_TESTING_LANGUAGE', value);
            }
        }
        ,
    }
;

export default languageModule;